import React, { useEffect, useState } from "react";
import {
  Select,
  Input,
  Form,
  Button,
  message,
  Modal,
  Checkbox,
  Spin,
} from "antd";
import {
  BrowserRouter as Router,
  Switch,
  Link,
  useLocation,
} from "react-router-dom";
import "../home-page.css";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import agent from "../../../agent";
import {
  LOGIN,
  SERVICELIST,
  DISTANCE,
} from "../../../core-units/constants/actionTypes";
import bannerBG from "../../../assets/img/bannerBG.png";
import _, { isEmpty } from "lodash";
import Ripples from "react-ripples";
import { connect } from "react-redux";
const { Option } = Select;

const Locations = (props) => {
  const homeLocation = "Ste 975/585 Little Collins St, Melbourne VIC 3000, Australia";
  const [selectedValuelocation, setSelectedValuelocation] = useState("");
  const [location_search_data, setLocation_search_data] = useState([]);
  const [fetching, setFetching] = useState(false); 
  const [locDiff, setLocDiff] = useState(0);
  const [lastLoginAttempt, setLastLoginAttempt] = useState(0);
  const [loginRetryCount, setLoginRetryCount] = useState(0);

  const parseLocationData = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
    } catch (error) {
      // ignore invalid JSON
    }
    if (typeof value === "string" && value.includes(",")) {
      return value.split(",").map((item) => Number(item.trim()));
    }
    return [];
  };

  const location = useLocation();
  const isEV = location.pathname.includes("/ev");

  const handleLogin = () => {
    if (loginInProgress) {
      return;
    }

    // Prevent retry storm: wait at least 3 seconds between attempts
    const now = Date.now();
    const timeSinceLastAttempt = now - lastLoginAttempt;
    const minRetryDelay = 3000;

    if (timeSinceLastAttempt < minRetryDelay) {
      return;
    }

    // Max 5 retry attempts to prevent infinite loops
    if (loginRetryCount > 5) {
      console.error(
        "[Location] Login retry limit exceeded. Check backend auth endpoint."
      );
      return;
    }

    setLastLoginAttempt(now);
    setLoginRetryCount((prev) => prev + 1);

    const request = {};
    props.auth(request, () => {
      setLoginRetryCount(0); // Reset on success
      props.servicesList();
    });
  };

  const authLoggedInValue = _.get(props, "auth.signupDetails.isLoggedIn", false);
  const loginInProgress = _.get(props, "auth.inProgress", false);
  const storedLoginStatus = localStorage.getItem("safebuyLoggedInStatus");
  const isLoggedIn =
    authLoggedInValue === true ||
    authLoggedInValue === "true" ||
    storedLoginStatus === "true";

  useEffect(() => {
    setLocDiff(localStorage.getItem("diffLoc"));
    setLocation_search_data(
      parseLocationData(localStorage.getItem("location_search_data"))
    );
    setSelectedValuelocation(localStorage.getItem("selectedValuelocation") || "");
  }, []);

  // Separate effect for auth check with retry logic
  useEffect(() => {
    if (!isLoggedIn && !loginInProgress) {
      handleLogin();
    }
  }, [isLoggedIn, loginInProgress, lastLoginAttempt]);

  /**Location search */
  const handleChange = (address) => {
    setSelectedValuelocation(address);
  };

  /**Location select */
  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        locationDifference(latLng);
        setSelectedValuelocation(address);
      })
      .catch((error) => console.error("Error", error));
  };
  const locationDifference = (latLng) => {
    const latLngD = [latLng.lat, latLng.lng];
    setLocation_search_data(latLngD);
  };
  /**Submit function  */
  const onSubmit = () => {
    if (
      !isEmpty(selectedValuelocation) ||
      !_.isEmpty(localStorage.getItem("selectedValuelocation"))
    ) {
      localStorage.removeItem("value");
      localStorage.removeItem("service");
      localStorage.removeItem("total");
      localStorage.removeItem("product");
      props.servicesList();
      document.getElementById("sample").scrollIntoView({
        behavior: "smooth",
      });

      // window.scrollTo(0, 5)
      props.servicesList();
      const origin = homeLocation;
      const destination = selectedValuelocation;

      props.distance(
        {
          origin,
          destination,
          destinationAddress: selectedValuelocation,
          mode: "driving",
        },
        (value) => {
          console.log("Distance API response (home):", value);
          const routes = _.get(value, "routes", []);
          let shortestDistanceKm = 0;

          if (routes.length > 0) {
            let shortestDistanceMeters = Number.MAX_SAFE_INTEGER;

            routes.forEach((route) => {
              (route.legs || []).forEach((leg) => {
                const distanceMeters = _.get(leg, "distanceMeters", _.get(leg, "distance.value", 0));
                if (distanceMeters < shortestDistanceMeters) {
                  shortestDistanceMeters = distanceMeters;
                }
              });
            });

            shortestDistanceKm = shortestDistanceMeters / 1000;
          }

          console.log("Shortest distance selected (home):", shortestDistanceKm);
          setLocDiff(shortestDistanceKm);
          setFetching(false);
          localStorage.setItem("diffLoc", shortestDistanceKm);
        },
      );
      localStorage.setItem("selectedValuelocation", selectedValuelocation);
      localStorage.setItem(
        "location_search_data",
        JSON.stringify(location_search_data)
      );
    }
  };

  //Edit Function --------

  const onEdit = () => {
    [
      "value",
      "service",
      "total",
      "product",
      "selectedValuelocation",
      "location_search_data",
      "diffLoc",
    ].forEach((key) => localStorage.removeItem(key));

    setSelectedValuelocation("");
    setLocation_search_data([]);
    setLocDiff(0);

    if (props.routingValidation.edit === 0) {
      setFetching(true);
    }
    if (props.routingValidation.edit === 1) {
      props.routingValidation.home();
    }
    if (props.routingValidation.edit === 2) {
      props.routingValidation.home();
    }
    if (props.routingValidation.edit === 3) {
      props.routingValidation.home();
    }
    if (props.routingValidation.edit === 4) {
      props.routingValidation.home();
    }
  };

  const render = () => {
    const searchOptions = {
      componentRestrictions: { country: "aus" },
    };
    return (
      <div
        className="BannerSection"
        style={{ backgroundImage: `url(${bannerBG})` }}
      >
        <div className="BannerTextContainer">
          <div className="container">
            <div className="row">
              <div className="col-8 col-md-4">
                <div className="BannerTextTitle">
                  <span className="text-nowrap">Whenever you buy</span>
                  <span className="txt-brown">SafeBuy</span>
                </div>
                <div className="BannerTextDesc">
                  <b>
                    Book your inspection by entering the car location (
                    <span className="address">Complete address</span>) in the
                    box below
                  </b>
                </div>
                <div className="BannerInputContainer">
                  <Form>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Please fill the location",
                        },
                      ]}
                    >
                      <PlacesAutocomplete
                        value={selectedValuelocation}
                        onChange={handleChange}
                        onSelect={handleSelect}
                        searchOptions={searchOptions}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            {props.routingValidation.route === false &&
                            _.isEmpty(
                              localStorage.getItem("selectedValuelocation"),
                            ) ? (
                              <Input
                                {...getInputProps({
                                  placeholder:
                                    "585 Collins Street, Melbourne , VIC 3000",
                                  className: "location-search-input",
                                })}
                                //disabled={props.routingValidation.route}
                                required
                              />
                            ) : (
                              <Input
                                {...getInputProps({
                                  placeholder:
                                    "585 Collins Street, Melbourne , VIC 3000",
                                  className: "location-search-input",
                                })}
                                disabled
                                required
                              />
                            )}

                            {_.isEmpty(selectedValuelocation) ? (
                              <span className="location-error-message">
                                Please fill this field!
                              </span>
                            ) : (
                              ""
                            )}
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion) => {
                                return (
                                  <div
                                    key={suggestion.index}
                                    {...getSuggestionItemProps(suggestion, {})}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </Form.Item>
                    <Form.Item>
                      <Ripples className="buttonRipple">
                        <Button
                          onClick={
                            props.routingValidation.route === false &&
                            _.isEmpty(
                              localStorage.getItem("selectedValuelocation"),
                            )
                              ? onSubmit
                              : onEdit
                          }
                          id="sample"
                        >
                          {props.routingValidation.route === false &&
                          _.isEmpty(
                            localStorage.getItem("selectedValuelocation"),
                          )
                            ? "Get Started"
                            : "Edit / Change"}
                        </Button>
                      </Ripples>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return render();
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  auth: (params, callback) =>
    dispatch({
      type: LOGIN,
      payload: agent.Auth.login(params),
      successNotification: false,
      callback: callback,
    }),
  servicesList: (params, callback) =>
    dispatch({
      type: SERVICELIST,
      payload: agent.Services.list(params),
      callback: callback,
    }),
  distance: (params, callback) =>
    dispatch({
      type: DISTANCE,
      payload: agent.Auth.google_location(params),
      callback: callback,
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(Locations);
